import { useForm } from 'react-hook-form';

import { ILineItemSubtype } from 'common/src/types/interfaces';

import { FormContainer } from 'portal/src/components/common/forms/FormContainer';
import GenericDialog from 'portal/src/components/common/GenericDialog';

import {
  defaultValues,
  getLineItemSubTypeFields,
} from './LineItemSubtype.fields';

const LineItemSubTypeForm = ({
  loading,
  open,
  onClose,
  onSave,
}: {
  loading?: boolean;
  open: boolean;
  onClose: () => void;
  onSave: (data: Partial<ILineItemSubtype>) => void;
}) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty },
  } = useForm({ defaultValues: defaultValues() });

  const submitForm = (data: Partial<ILineItemSubtype>) => {
    onSave(data);
  };

  const formFieldsConfig = getLineItemSubTypeFields();

  return (
    <GenericDialog open={open} onClose={onClose}>
      <FormContainer
        backButtonlabel="Cancel"
        buttonLayout="bottom"
        control={control}
        header="Add Line Item Subtype"
        isDirty={isDirty}
        isNew={true}
        isPending={loading}
        isSubmitDisabled={loading}
        mainFieldsConfig={formFieldsConfig}
        handleBackAction={onClose}
        handleSubmit={handleSubmit(submitForm)}
        removeContainerStyle={true}
      />
    </GenericDialog>
  );
};

export default LineItemSubTypeForm;
